/**
 * Objective Details Redirect Component
 *
 * Redirects /okr/objectives/:objectiveId to /okr with a toast notification.
 * Objective details now require cycleId in the route:
 * /okr/cycles/:cycleId/objectives/:objectiveId
 *
 * This redirect shows a helpful message prompting users to navigate
 * through the cycle first.
 */

import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useToast } from '@/hooks/useToast';

export default function ObjectiveDetailsRedirect() {
  const { objectiveId } = useParams<{ objectiveId: string }>();
  const toast = useToast();

  useEffect(() => {
    toast.info(
      'Para visualizar este objetivo, selecione o ciclo correspondente primeiro.',
      { duration: 5000 }
    );
  }, [toast]);

  return <Navigate to="/okr" replace />;
}
